import $ from 'jquery';

export default function () {

    $('.js-cross-fade-images').each(function () {

        let imgs = $(this).find('.js-fade-img');
        imgs.css('display', 'none');
        let image = imgs.first('.js-fade-img');
        image.fadeIn(1);
        if (imgs.length && imgs.length > 1) {
            window.setInterval(function () {

                image.fadeOut(1000);
                if (image.next('.js-fade-img').length && image.next('.js-fade-img').length > 0) {
                    image.next('.js-fade-img').fadeIn(1000);
                    image = image.next('.js-fade-img');
                } else {
                    image = imgs.first('.js-fade-img');
                    image.fadeIn(1000);
                }

            }, 3000);

        }
    });

}
